var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressBook = function SvgAddressBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6943 11.3886C12.2284 11.3886 13.4721 10.1449 13.4721 8.61079C13.4721 7.07666 12.2284 5.83301 10.6943 5.83301C9.16016 5.83301 7.9165 7.07666 7.9165 8.61079C7.9165 10.1449 9.16016 11.3886 10.6943 11.3886Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 5.13867H3.74984",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 10H3.74984",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 14.8613H3.74984",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52783 13.472C7.01297 12.8252 7.64206 12.3001 8.36526 11.9385C9.08847 11.5769 9.88593 11.3887 10.6945 11.3887C11.5031 11.3887 12.3005 11.5769 13.0237 11.9385C13.7469 12.3001 14.376 12.8252 14.8612 13.472",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6387 17.6392V2.36144C17.6387 1.97791 17.3278 1.66699 16.9442 1.66699L4.44423 1.66699C4.0607 1.66699 3.74978 1.97791 3.74978 2.36144L3.74978 17.6392C3.74978 18.0227 4.0607 18.3337 4.44423 18.3337H16.9442C17.3278 18.3337 17.6387 18.0227 17.6387 17.6392Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAddressBook;